import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMapPinFlat: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="map-pin-flat, route"><path d="M2.75 17.75V6.25C2.75 4.86929 3.86929 3.75 5.25 3.75H7V15.25H5.25C3.86929 15.25 2.75 16.3693 2.75 17.75ZM2.75 17.75C2.75 19.1307 3.86929 20.25 5.25 20.25H20.25V12.75M10.75 6.75H7M20.25 6.96429C20.25 9.64286 17 11.25 17 11.25C17 11.25 13.75 9.64286 13.75 6.96429C13.75 5.18908 15.2051 3.75 17 3.75C18.7949 3.75 20.25 5.18908 20.25 6.96429Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMapPinFlat;
